// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*------------------old--------------------*/    
.btn-outline-primary{
	color:#358696 ;
	border-color:#358696;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#358696;
	color:#fff;
}

.btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: #358696;
    border-color: #358696;
}
.btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: #358696;
    --bs-btn-border-color: #358696;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #358696;
    --bs-btn-hover-border-color: #358696;
    --bs-btn-focus-shadow-rgb: 49,132,253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #358696;
    --bs-btn-active-border-color: #358696;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #358696;
    --bs-btn-disabled-border-color: #358696;
}

.form-check-input:checked {
    background-color: #358696;
    border-color: #358696;
}
.form-select:focus {
    border-color: #358696;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
}

/* Tabs Section */
.nav-link:focus, .nav-link:hover {
    /* color: var(--bs-nav-link-hover-color); */
	color: #358696;
}
.nav-link{
	color: #999;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #358696;
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color);
}

/* Section Header<> */

.secHead34 {
    background-color: #d3eff4;
    padding: 10px;
    margin-bottom: 20px;
}

.bg-white{
	background-color:#fff;
}
.headBG {
box-sizing: border-box;
background: #FFFFFF;
border: 1px solid #358696;
}

.mainDiv{
	margin-top:80px;
}

.widget{
	background: #FFFFFF;
box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
}
.widgetIcon img{
	width:50px;height:50px;
}
.widgetIcon-32 img{
	width:32px;height:32px;
}
.sec2Charts .titlebg {
    font-size: 1.1em;
    color: #000;
    font-weight: 500 ;
    margin-bottom: 10px;
	text-align: left;
}
.titlebg {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
	text-align:center;
}
.chart3Title {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    text-align: left;
}
.chartboxPageOne{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    min-height: 293px;
}
.chartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
}
.chartbox3{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
	 min-height:330px; 
}

	h5, .h5 {
    font-size: 1.1rem !important;
}
p {
    line-height: 1rem !important;
}
small, .small {
    font-size: 80% !important;
}
	
table tr td {
	font-size:0.8em;
}
.accordion-button{
	font-size:0.5em;
}
.accordion-button:not(.collapsed){
	background-color:#e0e0e0;
	color:#222;
}

.filterForm > .form-label{
	font-size:0.825em;
}

.form-label{
	font-size:0.825em;
    background: transparent; 
	padding: 0px !important;
	text-align: left;
	 margin-bottom:0px !important;
	color: #358696 !important;
	font-weight: 600;
	display: block;

}
.Headfont{
	font-size:1.8rem;
}
.dropdown-menu[data-bs-popper] {
    right:0 !important;
	left: auto;
}

.logoTML{
	height:40px;
}

.boxHead{
	background: #D3EFF4;
	border-bottom: 1px solid #358696;
	padding:5px;
	height:30px;
	margin-bottom: 15px;
}
.boxHeadText{
	font-size:0.825em;
	font-weight:bold;
	color:#222;
}


.tableHold table thead{
	width: 100%;
}
.tableHold table thead tr{
	display:block;
}
.tableHold table tbody{
	display:block;
	width: 100%;
	height: 150px;
	overflow-y:scroll;
}
.tableHold table tbody tr{display:block;
}

/******* Table Content Page One *******/
.fixed_header{
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}

.fixed_header tbody{
  display:block;
  width: 100%;
  overflow: auto;
  height: 186px;
}

.fixed_header thead tr {
   display: block;
}

.fixed_header thead {
  background: black;
  color:#fff;
}

.fixed_header th, .fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}
	
/***************************** PageTwo *******************************/
.bt-graph {
    border-right: solid 1px #b5b5b5;
}

.icon-rgt {
    /* width: 62%; */
    float: right;
}
.icon-rgt-top {
    font-size: 13px;
    width: 100%;
    padding: 5px 0px 2px 0px;
}
.fst1 {
    border-left: solid 2px #ffa650;
    float: right;
    margin-right: 10px;
    padding-left: 5px;
    font-size: 11px;
}
.icon-rgt-top {
}
.fst {
    border-left: solid 2px #ffa650;
    padding-left: 5px;
    font-size: 11px;
}



/* media queries start here */

@media screen and (max-width: 1024px) {
.logoTML{
  height: 25px;
}
}

@media screen and (max-width: 1000px) {
.fixed_header tbody{
  height: 150px;
}
}

@media screen and (max-width: 991px) {
.mgt-2{margin-top:20px;}
}

@media screen and (max-width: 740px) {
.titlebg {
	font-size: 0.9em;
}
}

@media screen and (max-width: 720px) {
.mainDiv{
	margin-top:124px;
}
}

@media screen and (max-width: 480px) {
.mainDiv{
	margin-top:145px;
}
}

@media screen and (max-width: 375px) {
.mainDiv{
	margin-top:155px;
}
}
	
@media screen and (max-width: 480px) {
.topHeader h2{
	font-size: 22px;
    padding-right: 3rem;
}
	.titlebg {
		font-size: 0.9em;
	}
}

@media screen and (max-width: 320px) {
	.topHeader h2{
	font-size: 16px;
		padding-right: 0rem;
	}
}
.hand_geture:hover{
    color: blue;
}
.hand_geture {
    cursor: pointer !important;
}
.select_col_title {
	background: transparent; 
	padding: 0px !important;
	text-align: left;
	 margin-bottom:0px !important;
	color: #358696 !important;
	font-weight: 600;
	display: block;
  }
  .text-mutedf{
    font-size:1em !important;
  }`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Faultanalysis/FaultFirstPage/FaultFirstPageCustom.css"],"names":[],"mappings":";AACA,4CAA4C;AAC5C;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,qCAAqC;IACrC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,+CAA+C;AACnD;;AAEA,iBAAiB;AACjB;IACI,2CAA2C;CAC9C,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;IACI,cAAc;IACd,mDAAmD;IACnD,yDAAyD;AAC7D;;AAEA,qBAAqB;;AAErB;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;CACC,qBAAqB;AACtB;AACA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,yBAAyB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB,4CAA4C;AAC5C;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;CACtB,gBAAgB;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;CACtB,iBAAiB;AAClB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;EAChB,gBAAgB;AAClB;;CAEC;IACG,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;IACd,uBAAuB;CAC1B,uBAAuB;CACvB,gBAAgB;EACf,4BAA4B;CAC7B,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;;AAEf;AACA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;CACrB,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;CAChC,WAAW;CACX,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,UAAU;AACX;;;AAGA;CACC,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;CACb,WAAW;CACX,aAAa;CACb,iBAAiB;AAClB;AACA,0BAA0B,aAAa;AACvC;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;GACG,cAAc;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA,sEAAsE;AACtE;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;AACA;AACA;AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;AACnB;;;;AAIA,6BAA6B;;AAE7B;AACA;EACE,YAAY;AACd;AACA;;AAEA;AACA;EACE,aAAa;AACf;AACA;;AAEA;AACA,OAAO,eAAe,CAAC;AACvB;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,eAAe;IACZ,mBAAmB;AACvB;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;CACA,eAAe;EACd,mBAAmB;CACpB;AACD;AACA;IACI,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;AACA;CACC,uBAAuB;CACvB,uBAAuB;CACvB,gBAAgB;EACf,4BAA4B;CAC7B,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;EACb;EACA;IACE,wBAAwB;EAC1B","sourcesContent":["\r\n/*------------------old--------------------*/    \r\n.btn-outline-primary{\r\n\tcolor:#358696 ;\r\n\tborder-color:#358696;\r\n}\r\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\r\n\tbackground-color:#358696;\r\n\tcolor:#fff;\r\n}\r\n\r\n.btn:hover {\r\n    color: var(--bs-btn-hover-color);\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n.btn-primary {\r\n    --bs-btn-color: #fff;\r\n    --bs-btn-bg: #358696;\r\n    --bs-btn-border-color: #358696;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #358696;\r\n    --bs-btn-hover-border-color: #358696;\r\n    --bs-btn-focus-shadow-rgb: 49,132,253;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #358696;\r\n    --bs-btn-active-border-color: #358696;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #fff;\r\n    --bs-btn-disabled-bg: #358696;\r\n    --bs-btn-disabled-border-color: #358696;\r\n}\r\n\r\n.form-check-input:checked {\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n.form-select:focus {\r\n    border-color: #358696;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\r\n}\r\n\r\n/* Tabs Section */\r\n.nav-link:focus, .nav-link:hover {\r\n    /* color: var(--bs-nav-link-hover-color); */\r\n\tcolor: #358696;\r\n}\r\n.nav-link{\r\n\tcolor: #999;\r\n}\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n    color: #358696;\r\n    background-color: var(--bs-nav-tabs-link-active-bg);\r\n    border-color: var(--bs-nav-tabs-link-active-border-color);\r\n}\r\n\r\n/* Section Header<> */\r\n\r\n.secHead34 {\r\n    background-color: #d3eff4;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.bg-white{\r\n\tbackground-color:#fff;\r\n}\r\n.headBG {\r\nbox-sizing: border-box;\r\nbackground: #FFFFFF;\r\nborder: 1px solid #358696;\r\n}\r\n\r\n.mainDiv{\r\n\tmargin-top:80px;\r\n}\r\n\r\n.widget{\r\n\tbackground: #FFFFFF;\r\nbox-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\r\n}\r\n.widgetIcon img{\r\n\twidth:50px;height:50px;\r\n}\r\n.widgetIcon-32 img{\r\n\twidth:32px;height:32px;\r\n}\r\n.sec2Charts .titlebg {\r\n    font-size: 1.1em;\r\n    color: #000;\r\n    font-weight: 500 ;\r\n    margin-bottom: 10px;\r\n\ttext-align: left;\r\n}\r\n.titlebg {\r\n    font-size: 1.2em;\r\n    color: #000;\r\n    font-weight: 500;\r\n    margin-bottom: 10px;\r\n\ttext-align:center;\r\n}\r\n.chart3Title {\r\n    font-size: 1.2em;\r\n    color: #000;\r\n    font-weight: 500;\r\n    text-align: left;\r\n}\r\n.chartboxPageOne{\r\n\tbackground: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n    min-height: 293px;\r\n}\r\n.chartbox{\r\n\tbackground: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n    /* font-size: 14px; */\r\n}\r\n.chartbox3{\r\n\tbackground: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n\t min-height:330px; \r\n}\r\n\r\n\th5, .h5 {\r\n    font-size: 1.1rem !important;\r\n}\r\np {\r\n    line-height: 1rem !important;\r\n}\r\nsmall, .small {\r\n    font-size: 80% !important;\r\n}\r\n\t\r\ntable tr td {\r\n\tfont-size:0.8em;\r\n}\r\n.accordion-button{\r\n\tfont-size:0.5em;\r\n}\r\n.accordion-button:not(.collapsed){\r\n\tbackground-color:#e0e0e0;\r\n\tcolor:#222;\r\n}\r\n\r\n.filterForm > .form-label{\r\n\tfont-size:0.825em;\r\n}\r\n\r\n.form-label{\r\n\tfont-size:0.825em;\r\n    background: transparent; \r\n\tpadding: 0px !important;\r\n\ttext-align: left;\r\n\t margin-bottom:0px !important;\r\n\tcolor: #358696 !important;\r\n\tfont-weight: 600;\r\n\tdisplay: block;\r\n\r\n}\r\n.Headfont{\r\n\tfont-size:1.8rem;\r\n}\r\n.dropdown-menu[data-bs-popper] {\r\n    right:0 !important;\r\n\tleft: auto;\r\n}\r\n\r\n.logoTML{\r\n\theight:40px;\r\n}\r\n\r\n.boxHead{\r\n\tbackground: #D3EFF4;\r\n\tborder-bottom: 1px solid #358696;\r\n\tpadding:5px;\r\n\theight:30px;\r\n\tmargin-bottom: 15px;\r\n}\r\n.boxHeadText{\r\n\tfont-size:0.825em;\r\n\tfont-weight:bold;\r\n\tcolor:#222;\r\n}\r\n\r\n\r\n.tableHold table thead{\r\n\twidth: 100%;\r\n}\r\n.tableHold table thead tr{\r\n\tdisplay:block;\r\n}\r\n.tableHold table tbody{\r\n\tdisplay:block;\r\n\twidth: 100%;\r\n\theight: 150px;\r\n\toverflow-y:scroll;\r\n}\r\n.tableHold table tbody tr{display:block;\r\n}\r\n\r\n/******* Table Content Page One *******/\r\n.fixed_header{\r\n    width: 100%;\r\n    table-layout: fixed;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.fixed_header tbody{\r\n  display:block;\r\n  width: 100%;\r\n  overflow: auto;\r\n  height: 186px;\r\n}\r\n\r\n.fixed_header thead tr {\r\n   display: block;\r\n}\r\n\r\n.fixed_header thead {\r\n  background: black;\r\n  color:#fff;\r\n}\r\n\r\n.fixed_header th, .fixed_header td {\r\n  padding: 5px;\r\n  text-align: left;\r\n  width: 200px;\r\n}\r\n\t\r\n/***************************** PageTwo *******************************/\r\n.bt-graph {\r\n    border-right: solid 1px #b5b5b5;\r\n}\r\n\r\n.icon-rgt {\r\n    /* width: 62%; */\r\n    float: right;\r\n}\r\n.icon-rgt-top {\r\n    font-size: 13px;\r\n    width: 100%;\r\n    padding: 5px 0px 2px 0px;\r\n}\r\n.fst1 {\r\n    border-left: solid 2px #ffa650;\r\n    float: right;\r\n    margin-right: 10px;\r\n    padding-left: 5px;\r\n    font-size: 11px;\r\n}\r\n.icon-rgt-top {\r\n}\r\n.fst {\r\n    border-left: solid 2px #ffa650;\r\n    padding-left: 5px;\r\n    font-size: 11px;\r\n}\r\n\r\n\r\n\r\n/* media queries start here */\r\n\r\n@media screen and (max-width: 1024px) {\r\n.logoTML{\r\n  height: 25px;\r\n}\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n.fixed_header tbody{\r\n  height: 150px;\r\n}\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n.mgt-2{margin-top:20px;}\r\n}\r\n\r\n@media screen and (max-width: 740px) {\r\n.titlebg {\r\n\tfont-size: 0.9em;\r\n}\r\n}\r\n\r\n@media screen and (max-width: 720px) {\r\n.mainDiv{\r\n\tmargin-top:124px;\r\n}\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n.mainDiv{\r\n\tmargin-top:145px;\r\n}\r\n}\r\n\r\n@media screen and (max-width: 375px) {\r\n.mainDiv{\r\n\tmargin-top:155px;\r\n}\r\n}\r\n\t\r\n@media screen and (max-width: 480px) {\r\n.topHeader h2{\r\n\tfont-size: 22px;\r\n    padding-right: 3rem;\r\n}\r\n\t.titlebg {\r\n\t\tfont-size: 0.9em;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n\t.topHeader h2{\r\n\tfont-size: 16px;\r\n\t\tpadding-right: 0rem;\r\n\t}\r\n}\r\n.hand_geture:hover{\r\n    color: blue;\r\n}\r\n.hand_geture {\r\n    cursor: pointer !important;\r\n}\r\n.select_col_title {\r\n\tbackground: transparent; \r\n\tpadding: 0px !important;\r\n\ttext-align: left;\r\n\t margin-bottom:0px !important;\r\n\tcolor: #358696 !important;\r\n\tfont-weight: 600;\r\n\tdisplay: block;\r\n  }\r\n  .text-mutedf{\r\n    font-size:1em !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
